import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  BokkzAlgDataService,
  BokkzMumaDataService,
  MumaEntity,
  MumaEntityMachtigingStatus,
  MumaRequestDienst,
  MumaRequestMutatieType
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ToastService} from "@snelstart/ui-toast";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiAlertModule} from "@snelstart/ui-alert";

@Component({
  selector: 'snelstart-venture-fiscaal-muma',
  standalone: true,
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiButtonModule, SharedUiAlertModule],
  templateUrl: './muma.component.html',
  styleUrl: './muma.component.scss',
})
export class MumaComponent implements OnInit, OnChanges {

  @Input() public id!: string;
  public clientId: any;
  public mumaEntity = {} as MumaEntity;
  public formGroup = {} as FormGroup;
  public formGroupStatus = {} as FormGroup;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzMumaDataService,
    public toastService: ToastService,
    public fb: FormBuilder,
  ) {
    this.formGroup = this.fb.group({
      taxPayerFiscalNumber: null as unknown as string,
      year: null as unknown as number,
      type: null as unknown as string,
      mumaRequest: this.fb.group({
        bsn: null as unknown as string,
        dienst: null as unknown as MumaRequestDienst,
        activatieToken: null as unknown as string,
        aanleverkenmerk: null as unknown as string,
        mutatieType: null as unknown as MumaRequestMutatieType,
        gemachtigdeIdentiteitsNummer: null as unknown as string,
      }),
      machtigingStatus: null as unknown as MumaEntityMachtigingStatus,
      machtigingStatusToelichting: null as unknown as string,
      submissionDate: null as unknown as Date,
      lastCheckDate: null as unknown as Date,
    })
    this.formGroupStatus = this.fb.group({
      status: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.dataService.mumaEntity.subscribe((value) => {
      if (value) {
        this.mumaEntity = value;
        this.updateFormWithTransformedData();
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const idChanges = changes['id'];
    if (idChanges && idChanges.currentValue !== idChanges.previousValue) {
      this.algDataService.client.subscribe((value) => {
        this.clientId = value.id;
      })
      this.dataService.mumaEntity.subscribe((value) => {
        this.formGroup.reset()
        if (value) {
          this.mumaEntity = value;
          this.formGroup.patchValue(value);
          this.setStatus(value);
          setTimeout(() => {
            this.updateFormWithTransformedData();
          }, 0);
        }
      });
    }
  }

  public checkIsOptInMachtiging(dienst?: MumaRequestDienst) {
    return dienst?.toString().includes('SBA_TSG')
      || dienst?.toString().includes('VIA')
      || dienst?.toString().includes('DoMa')
  }

  saveForm(): void {
    this.formGroup.updateValueAndValidity();
    this.dataService.updateActivatieCode(this.formGroup.value.mumaRequest.activatieToken)
  }

  private setStatus(muma: MumaEntity) {
    if (muma.machtigingStatus === MumaEntityMachtigingStatus.ACTIEF) {
      this.formGroupStatus.patchValue({status: "Actief"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.ONTVANGEN) {
      this.formGroupStatus.patchValue({status: "Ontvangen"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.CONTROLEREN) {
      this.formGroupStatus.patchValue({status: "Controleren"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.NIET_ACTIEF) {
      this.formGroupStatus.patchValue({status: "Niet actief"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.UNKNOWN) {
      this.formGroupStatus.patchValue({status: "Onbekend"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && this.checkIsOptInMachtiging(muma.mumaRequest?.dienst)) {
      this.formGroupStatus.patchValue({status: "Activeren"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && !this.checkIsOptInMachtiging(muma.mumaRequest?.dienst)) {
      this.formGroupStatus.patchValue({status: "In behandeling"});
    }
    else if (muma.machtigingStatus === MumaEntityMachtigingStatus.AFGEKEURD) {
      this.formGroupStatus.patchValue({status: "Afgekeurd"});
    }
  }

  private updateFormWithTransformedData(): void {
    const originalText = this.mumaEntity.machtigingStatusToelichting;
    const transformedText = originalText ?
      originalText.replace(/Digipoort/g, 'de Belastingdienst') : '';
    this.formGroup.patchValue({
      machtigingStatusToelichting: transformedText
    });
  }

}
